import React from 'react';

import AccordionItem from './__item/accordion__item';
import { AccordionItemData, AccordionItemId } from './typings';

export interface Props {
    items: Array<AccordionItemData>;
    expandedItem: AccordionItemId | null;
}

export const Accordion = ({ items, expandedItem }: Props) => {
    return (
        <div className="accordion qa_accordion">
            {items.map((item) => (
                <AccordionItem {...item} isExpanded={item.id === expandedItem} key={item.id} />
            ))}
        </div>
    );
};

export default Accordion;
